"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var create_entity_1 = require("../../utils/create-entity");
var current_user_can_1 = require("../../utils/current-user-can");
exports.Banner = {
  name: 'Banner',
  valueImageStyle: 'banner',
  list: {
    resultsVariant: "list",
    hasSearch: true
  },
  autoRoutes: ['list', 'create', 'update'],
  table: {
    fieldNames: ["name", "image"]
  },
  form: {
    paginate: true,
    bufferAtEnd: 50,
    modal: {
      fill: true,
      maxWidth: "1200px"
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'breakpoint-images'
    }, {
      name: 'references'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      image: {
        type: 'image',
        recommended: true,
        fieldSet: 'overview',
        maxPreviewWidth: 250,
        description: 'Please provide a 16:9 image for this {{BANNER}}. For best results, this image should be a size of 1184 pixels (wide) x 666 pixels (high).'
      },
      thumbnail: {
        type: 'image',
        recommended: true,
        fieldSet: 'overview',
        maxPreviewWidth: 150,
        description: 'Please provide a smaller 16:9 image to use for listing cards for the item this {{BANNER}} is related to.'
      },
      image2x: {
        type: 'image',
        recommended: false,
        fieldSet: 'overview',
        maxPreviewWidth: 350,
        description: 'Provide a double-resolution 16:9 image for this {{BANNER}} if you want the best quality on high resolution devices. For best results, this image should be a size of 2368 pixels (high) x 1332 pixels (wide).'
      },
      description: {
        type: 'longText',
        fieldSet: 'overview',
        description: 'Provide a description for this {{BANNER}}, for example a photography credit or description of what is in the image.'
      },
      portraitImage: {
        type: 'image',
        recommended: false,
        fieldSet: 'breakpoint-images',
        maxPreviewWidth: 350,
        description: 'Provide a portrait aspect (height > width) version of this image suitable for phones in portrait mode.'
      },
      landscapeImage: {
        type: 'image',
        recommended: false,
        fieldSet: 'breakpoint-images',
        maxPreviewWidth: 350,
        description: 'Provide a landscape aspect (width > height) version of this image suitable for phones when in landscape mode.'
      },
      tabletImage: {
        type: 'image',
        recommended: false,
        fieldSet: 'breakpoint-images',
        maxPreviewWidth: 350,
        description: 'Provide a version of this image suitable for tablets in portrait mode. If not provided the standard image will be used.'
      },
      largeImage: {
        type: 'image',
        recommended: false,
        fieldSet: 'breakpoint-images',
        maxPreviewWidth: 350,
        description: 'Provide a version of this image suitable for very large desktop devices. If not provided the standard image will be used.'
      },
      alternateText: {
        type: 'text',
        fieldSet: 'references',
        description: 'Provide alternate text for this {{BANNER}} for accessibility. Note: this may not always be necessary, as a banner is typically paired with an object which has a title anyway.'
      },
      title: {
        type: 'text',
        fieldSet: 'references',
        description: 'An optional description to override the default title at the bottom of this {{BANNER}}.'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'references'
      },
      sites: {
        type: 'linkedMultiple',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCanAdmin)();
        },
        entityTypeName: 'Site',
        description: "Does this {{BANNER}} relate to any specific {{SITES}}? If not, leave this blank."
      }
    })
  }
};